import { buildDocument } from "./build-document";

/** 메뉴 (헤더/푸터 등 handle로 조회) */
export const menuQuery = buildDocument(`#graphql
  query Menu($handle: String!) {
    menu(handle: $handle) {
      handle
      items {
        ...MenuItemBaseFields
        tags
        resourceId
        resource {
          ...CollectionSummaryFields
        }
        items {
          ...MenuItemBaseFields
          resource {
            ...CollectionSummaryFields
          }
          items {
            ...MenuItemBaseFields
          }
        }
      }
    }
  }
`);

export const shopQuery = buildDocument(`#graphql
  query Shop {
    shop {
      termsOfService { ...ShopPolicyFields }
      privacyPolicy { ...ShopPolicyFields }
      shippingPolicy { ...ShopPolicyFields }
      refundPolicy { ...ShopPolicyFields }
    }
  }
`);

/** Shopify 페이지 (handle로 조회) */
export const pageQuery = buildDocument(`#graphql
  query Page($handle: String!) {
    page(handle: $handle) {
      id
      handle
      title
      body
      bodySummary
      seo { ...SeoFields }
    }
  }
`);
